import PokemonSelectInput from "../../../components/PokemonSelectInput"
import type { PokemonOption } from "../../../types/pokemon"

interface OffencePokemonSelectProps {
  pokemonOptions: PokemonOption[]
  handleAddAttackPokemon: (event: any, newValue: any) => void
}

function OffencePokemonSelect({ pokemonOptions, handleAddAttackPokemon }: OffencePokemonSelectProps) {
  return (
    <PokemonSelectInput
      pokemonOptions={pokemonOptions}
      handleAddAttackPokemon={handleAddAttackPokemon}
      label="攻撃ポケモンを追加"
      placeholder="攻撃ポケモンを選択して追加"
    />
  )
}

export default OffencePokemonSelect
